import { Menubar } from 'primereact/menubar';
// import "primereact/resources/themes/vela-blue/theme.css"; // edit vela-blue to change theme
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { useState, useEffect } from 'react';
import { blueFontSmall } from './mylib';     
import {checkBCEndpoint, checkIPFSEndpoint} from './BCEndpoints.js';
import configuration from './configuration.json';
import aboutIcon from './about.png';
import './Nav.css';
import testingIcon from './testing_icon-icons.com_72182.png'
import loginIcon from './Login_37128.png'

const Navigation = () => {
    const [selectedModel, setSelectedModel] = useState(localStorage.getItem("selectedLLMModel") || 'Default -> mixtral');
    const [selectedOllama, setSelectedOllama] = useState(localStorage.getItem("selectedOllama") || 'http://');
    const [ChromaDBPath, setChromaDBPath] = useState(localStorage.getItem("selectedChromaDB") || 'http://');
    const [multiAgentAPI, setMultiAgentAPI] = useState(localStorage.getItem("selectedMultiAgent") || 'http://');

    // Shared-worker availability poll, lifted from dbFromCorpusPapers so
    // every page can see whether the ingestion worker is free/busy/down
    // at a glance. Pill in the end-slot below.
    const [worker, setWorker] = useState({
        loaded: false, reachable: false, running: false,
        analyst: '', collection: '', profile: '',
        started_at: '', done: 0, total: 0,
        coref_done: 0, coref_total: 0,
    });
    useEffect(() => {
        // Same runtime-host pattern as dbFromCorpusPapers — local-dev
        // uses the user's Mac Flask, prod uses the same-origin nginx
        // proxy. We honor any explicit localStorage('ingestAPI')
        // override so reviewers who manually pointed at a different
        // backend still see status from their chosen target.
        const cfg = (configuration && configuration.passer) || {};
        const isLocal = typeof window !== 'undefined'
            && ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname);
        const fallback = isLocal
            ? (cfg.IngestAPI || 'http://127.0.0.1:8010')
            : (cfg.IngestAPIRemote || 'https://passer.scpdx.net/ingest');
        const ingestAPI = (localStorage.getItem('ingestAPI') || fallback)
            .replace(/\/$/, '');
        let cancelled = false;
        const tick = async () => {
            try {
                const r = await fetch(ingestAPI + '/status',
                    { signal: AbortSignal.timeout(4000) });
                if (!r.ok) throw new Error('HTTP ' + r.status);
                const s = await r.json();
                if (cancelled) return;
                setWorker({
                    loaded: true, reachable: true,
                    running: !!s.running,
                    analyst:    s.analyst    || '',
                    collection: s.collection || '',
                    profile:    s.profile    || '',
                    started_at: s.started_at || '',
                    done:       s.done       || 0,
                    total:      s.total      || 0,
                    coref_done:  s.coref_done  || 0,
                    coref_total: s.coref_total || 0,
                });
            } catch (_) {
                if (!cancelled) setWorker(w => ({ ...w,
                    loaded: true, reachable: false, running: false }));
            }
        };
        tick();
        const id = setInterval(tick, 5000);
        return () => { cancelled = true; clearInterval(id); };
    }, []);

    useEffect(() => {
        // Protocol-mismatch guard: ensure the saved Ollama / Chroma URLs
        // match the page's scheme. On HTTPS, an HTTP URL hits mixed-
        // content blocking; on HTTP, an HTTPS URL fails CORS (or is
        // slower for no reason). Auto-select the first compatible
        // entry from configuration.json IF the saved value is missing
        // or mismatched. We do NOT overwrite a saved value that's
        // already compatible — that's the user's explicit pick.
        const isHttps = typeof window !== 'undefined'
            && window.location.protocol === 'https:';
        const wantScheme = isHttps ? 'https:' : 'http:';
        // The dev entry for gpuvm Ollama used to be plain HTTP over the
        // internet; it now goes through the Mac's SSH tunnel. Carry an old
        // saved pick over so it doesn't keep using the unencrypted URL.
        if ((localStorage.getItem('selectedOllama') || '').trim() === 'http://195.230.127.226:11850') {
            localStorage.setItem('selectedOllama', 'http://127.0.0.1:11850');
        }
        const fixUrl = (key, configList) => {
            const cur = (localStorage.getItem(key) || '').trim();
            // Respect any explicit user pick that matches a configured
            // entry — regardless of protocol. The user is the boss.
            const knownUrls = configList.map(o => (o.url || '').trim()).filter(Boolean);
            if (cur && knownUrls.includes(cur)) return;
            // Otherwise: if the stored value already matches the page's
            // protocol, leave it alone (the user may have typed a custom
            // URL we don't have in the config).
            if (cur && cur.toLowerCase().startsWith(wantScheme)) return;
            // Only when there's a clear mismatch do we rewrite to the
            // first protocol-compatible entry from the config list.
            const pick = configList.find(o => (o.url || '').toLowerCase().startsWith(wantScheme));
            if (pick) {
                localStorage.setItem(key, pick.url);
            }
        };
        fixUrl('selectedOllama',   configuration.passer.Ollama || []);
        fixUrl('selectedChromaDB', configuration.passer.Chroma || []);

        checkBCEndpoint().then(async (res) => {
            localStorage.setItem("bcEndpoint", res);
        });
        checkIPFSEndpoint().then(async (res) => {
            localStorage.setItem("ipfsEndpoint_host", res.host);
            localStorage.setItem("ipfsEndpoint_port", res.port);
        });
    }, []);

    const navlist = [
      { label: 'About', icon: <img src={aboutIcon} alt="About" width="22" height="22" />, command: () => {
          window.location.href = './#/about';
        }
      },
      {
        label: 'Create Vectorstore',
        icon: <span style={{ color: 'red' }} className="pi pi-fw pi-plus"></span>,
        items: [
          { label: 'From Text', icon: <span style={{ color: 'red' }} className="pi pi-fw pi-file"></span>, command: () => { window.location.href = './#/dbfromtext'; } },
          { label: 'From PDF/DOCX', icon: <span style={{ color: 'red' }} className="pi pi-fw pi-file-pdf"></span>, command: () => { window.location.href = './#/dbfrompdf'; } },
          { label: 'From WEB', icon: <span style={{ color: 'red' }} className="pi pi-fw pi-globe"></span>, command: () => { window.location.href = './#/dbfromweb'; } },
          { label: 'From Paper Corpus', icon: <span style={{ color: 'red' }} className="pi pi-fw pi-book"></span>, command: () => { window.location.href = './#/dbfromcorpuspapers'; } }
        ]
      },
      {
        label: 'Paper Scoring',
        icon: <span style={{ color: '#7b1fa2' }} className="pi pi-fw pi-star"></span>,
        command: () => { window.location.href = './#/scorepapersbat'; }
      },
      {
        label: 'Chat',
        icon: <span style={{ color: 'green' }} className="pi pi-fw pi-comments"></span>,
        items: [
          { label: 'Chat with LLM', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-comments"></span>, command: () => { window.location.href = './#/gpt'; } },
          { label: 'RAG Q&A with LLM', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-question-circle"></span>, command: () => { window.location.href = './#/chatfromdb'; } },
          { label: 'NewRAG (paper corpus chat)', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-book"></span>, command: () => { window.location.href = './#/chatnewrag'; } },
          { label: 'Chat with LLM MultiAgent', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-users"></span>, command: () => { window.location.href = './#/chatfromdbmultiagent'; } },
          { label: 'Chat over Picture', icon: <span style={{ color: '#0ea5a4' }} className="pi pi-fw pi-camera"></span>, command: () => { window.location.href = './#/chatoverpicture'; } },
          { label: 'Text to Image with LLM', icon: <span style={{ color: '#0ea5a4' }} className="pi pi-fw pi-image"></span>, command: () => { window.location.href = './#/t2imgchat'; } },
          { label: 'Image Edit with LLM', icon: <span style={{ color: '#0ea5a4' }} className="pi pi-fw pi-image"></span>, command: () => { window.location.href = './#/t2imgedit'; } },
          { label: 'Compose from Several Images', icon: <span style={{ color: '#0ea5a4' }} className="pi pi-fw pi-images"></span>, command: () => { window.location.href = './#/imagecompose'; } },
          { label: 'Diagram Creation with LLM', icon: <span style={{ color: '#0ea5a4' }} className="pi pi-fw pi-sitemap"></span>, command: () => { window.location.href = './#/diagramchat'; } },
          { label: 'MultiAgent Single Chat', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-users"></span>, command: () => { window.location.href = './#/testmultiagentbat'; } }
        ]
      },
      {
        label: 'Tests',
        icon: <img src={testingIcon} alt="Tests" width="20" height="20" />,
        items: [
          { label: 'Q&A Dataset', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-database"></span>, command: () => { window.location.href = './#/qatest'; } },
          { label: 'RAG Q&A Score Test', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-chart-line"></span>, command: () => { window.location.href = './#/testRAGbat'; } },
          { label: 'Q&A Score Test with Finetune', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-sliders-h"></span>, command: () => { window.location.href = './#/finetuneTestbat'; } },
          { label: 'Show Test Results', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-table"></span>, command: () => { window.location.href = './#/showTestResults'; } },
          { label: 'Q&A Time LLM Tests', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-clock"></span>, command: () => { window.location.href = './#/testtimebat'; } },
          { label: 'Show Time Test Results', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-table"></span>, command: () => { window.location.href = './#/showTimeTestResults'; } },
          { label: 'MultiAgent Batch Test', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-users"></span>, command: () => { window.location.href = './#/testmultiagentbatch'; } },
          { label: 'Screening Test', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-filter"></span>, command: () => { window.location.href = './#/screening'; } },
          { label: 'Retrieval Gold Labelling', icon: <span style={{ color: 'green' }} className="pi pi-fw pi-check-square"></span>, command: () => { window.location.href = './#/labellingtests'; } }
        ]
      },
      {
        label: 'OCR',
        icon: <span style={{ color: 'blue' }} className="pi pi-fw pi-file-o"></span>,
        command: () => { window.location.href = './#/ocr'; }
      },
      {
        label: 'Configuration',
        icon: <span style={{ color: 'blue' }} className="pi pi-fw pi-cog"></span>,
        items: [
          { label: 'Settings', icon: <span style={{ color: 'blue' }} className="pi pi-fw pi-cog"></span>, command: () => { window.location.href = './#/selectmodel'; } },
          { label: 'Add/Remove Model', icon: <span style={{ color: 'blue' }} className="pi pi-fw pi-plus-circle"></span>, command: () => { window.location.href = './#/addmodel'; } }
        ]
      },
      { label: 'ManageDB', icon: <span style={{ color: 'purple' }} className="pi pi-fw pi-server"></span>, command: () => { window.location.href = './#/managedb'; } },
      { label: 'AnchorLogin', icon: <span style={{ color: 'orange' }} className="pi pi-fw pi-key"></span>, command: () => { window.location.href = './#/testwharf'; } },
      // Cosmetic only — gpu-admin itself checks a signed token for admin accounts.
      ...(localStorage.getItem('wharf_user_name') === 'boni'
        ? [{ label: 'GPU Admin', icon: <span style={{ color: '#dc2626' }} className="pi pi-fw pi-shield"></span>, command: () => { window.location.href = './#/gpuadmin'; } },
           { label: 'Agent Governance', icon: <span style={{ color: '#16a34a' }} className="pi pi-fw pi-wallet"></span>, command: () => { window.location.href = './#/agentgov'; } }]
        : [])
    ];
    
    return(

        <header>
            <nav>
                <ul>
                    <Menubar
                        model={navlist}
                        end={
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <WorkerStatusPill worker={worker} />
                                <div>
                                    <div style={blueFontSmall}><b>OllamaAPI:</b>{selectedOllama} | <b>Model:</b>{selectedModel}</div>
                                    <div style={blueFontSmall}><b>ChromaAPI:</b>{ChromaDBPath} | <b>BCName:</b>{localStorage.getItem('wharf_user_name')}</div>
                                    <div style={blueFontSmall}><b>MultiAgentAPI:</b>{multiAgentAPI}</div>
                                </div>
                            </div>
                        }
                    />
                </ul>
            </nav>
         </header>


        // <div style={{ display: 'flex', width: '100%'}}>
        //     <div style={{width: '10%', display: 'flex'}} >
        //         <TieredMenu model={navlist} />
        //         <span style={{marginLeft: '20px'}}>
        //             <div style={blueFontSmall}>
        //                 <br/>
        //                 {selectedOllama} | {selectedModel} | {ChromaDBPath}
        //             </div>
        //         </span>
        //     </div>
        // </div>
    )

}

// Compact ingestion-worker status pill shown in the menu bar's end-slot.
// Updates live via the polling effect in Navigation above. Hover the
// pill for a tooltip with full progress + ETA.
function WorkerStatusPill({ worker }) {
    if (!worker.loaded) return null;

    let bg, fg, icon, label, tooltip;
    if (!worker.reachable) {
        bg = '#fee2e2'; fg = '#991b1b'; icon = 'pi-times-circle';
        label = 'Ingest down';
        tooltip = 'Ingestion worker unreachable.';
    } else if (worker.running) {
        // Pull progress + ETA from whichever bucket is active
        let elapsedMs = 0;
        try {
            if (worker.started_at)
                elapsedMs = Date.now() - new Date(worker.started_at).getTime();
        } catch (_) {}
        let pct = 0, label2 = '';
        if (worker.coref_total > 0) {
            pct = Math.round(worker.coref_done / worker.coref_total * 100);
            label2 = `coref ${worker.coref_done}/${worker.coref_total}`;
        } else if (worker.total > 0) {
            pct = Math.round(worker.done / worker.total * 100);
            label2 = `${worker.done}/${worker.total} files`;
        }
        const elapsedMin = Math.max(0, Math.round(elapsedMs / 60000));
        let etaMin = null;
        if (pct > 0 && pct < 100 && elapsedMs > 5000) {
            etaMin = Math.round(((elapsedMs / pct) * (100 - pct)) / 60000);
        }
        bg = '#fef3c7'; fg = '#92400e'; icon = 'pi-spin pi-spinner';
        label = `Busy: ${worker.analyst || '?'} → ${worker.collection || '?'}`
              + (pct > 0 ? ` (${pct}%)` : '');
        tooltip = `${worker.analyst || 'anonymous'} is ingesting into `
                + `${worker.collection || '?'}`
                + (worker.profile ? ` (profile ${worker.profile})` : '')
                + `\n${label2}`
                + (elapsedMin > 0 ? ` · elapsed ${elapsedMin}m` : '')
                + (etaMin != null ? ` · ETA ~${etaMin}m` : '');
    } else {
        bg = '#d1fae5'; fg = '#065f46'; icon = 'pi-check-circle';
        label = 'Ingest free';
        tooltip = 'Ingestion worker is available — no run in progress.';
    }
    return (
        <span title={tooltip}
              style={{
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                  padding: '4px 10px', borderRadius: 12,
                  fontSize: 11.5, fontWeight: 600,
                  background: bg, color: fg,
                  cursor: 'default', whiteSpace: 'nowrap',
              }}>
            <i className={'pi ' + icon} style={{ fontSize: 12 }} />
            {label}
        </span>
    );
}

export default Navigation;